var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"livechatMaintain","content-class":"popup-livechat","hide-footer":""}},[_c('div',{staticClass:"livechat"},[_c('img',{attrs:{"src":`${this.$store.state.mapDomain.STATIC_URL}/assets/img/livechat/notify.png`,"alt":"livechat"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }